import { Link } from 'react-router-dom';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function NotFound() {
  useDocumentMeta({
    title: '页面未找到 - 午夜电影网',
    description: '你访问的页面不存在，可能是链接有误。返回午夜电影网首页，继续浏览高清电影与影视资讯。',
    keywords: '午夜电影网,页面未找到',
  });

  return (
    <div className="shell flex min-h-[70vh] flex-col items-center justify-center pb-16 pt-32 text-center">
      <p className="font-heading text-7xl font-bold tracking-[0.1em] text-primary-500 md:text-9xl">404</p>
      <h1 className="mt-4 font-heading text-2xl tracking-wide text-foreground-950 md:text-3xl">这一卷胶片走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-7 text-foreground-500">
        你访问的页面不存在，可能是链接地址有误，或者内容已经被移动。回到首页，或者去片库重新挑一部。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true"></i>
          返回首页
        </Link>
        <Link
          to="/movies"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-500/70 hover:text-primary-500"
        >
          <i className="ri-film-line" aria-hidden="true"></i>
          浏览电影片库
        </Link>
      </div>
    </div>
  );
}